import { render, staticRenderFns } from "./EvaluatePeriodicCommonDialog.vue?vue&type=template&id=a8cbf370&scoped=true"
import script from "./EvaluatePeriodicCommonDialog.vue?vue&type=script&lang=js"
export * from "./EvaluatePeriodicCommonDialog.vue?vue&type=script&lang=js"
import style0 from "./EvaluatePeriodicCommonDialog.vue?vue&type=style&index=0&id=a8cbf370&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8cbf370",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8cbf370')) {
      api.createRecord('a8cbf370', component.options)
    } else {
      api.reload('a8cbf370', component.options)
    }
    module.hot.accept("./EvaluatePeriodicCommonDialog.vue?vue&type=template&id=a8cbf370&scoped=true", function () {
      api.rerender('a8cbf370', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/EvaluatePeriodicCommonDialog.vue"
export default component.exports